<template>
  <div>
    <div class="h-title">偏远邮编查询</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :model="form" :inline="true" size="small">
          <el-form-item label="邮编">
            <el-input v-model="form.zipcode" type="textarea" placeholder="请输入邮编"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-table :data="tableData">
      <el-table-column prop="zipcode" label="邮编" width="180"/>
      <el-table-column prop="desc" label="描述" width="180"/>
      <el-table-column prop="country" label="国家" width="180"/>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
     return {
      form:{
        zipcode: ''
      },
      tableData: []
     } 
    },
    methods: {
      query(){
        let _this = this
        let url = tmsSpringUrl.replace('seller/', '')
        this.$request1.post( url + '/op/remote-zipcode',
        {
              zipcode: this.form.zipcode
        },
        {
          withCredentials: true,
        }
        ).then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.tableData = response.data.data;
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/op/remote_zipcode.vue